import { useEffect, useState } from "react";

type AmountFormattedProps = {
  children: number;
  locale?: string;
  options?: Intl.NumberFormatOptions;
  countUp?: boolean;
  duration?: number;
  startValue?: number;
};

export const AmountFormatted = ({
  children,
  locale = "de-DE",
  options = {},
  countUp = false,
  duration = 1000,
  startValue = 0,
}: AmountFormattedProps) => {
  const [displayValue, setDisplayValue] = useState(
    countUp ? startValue : children
  );

  useEffect(() => {
    if (!countUp) {
      setDisplayValue(children);
      return;
    }

    const startTime = Date.now();
    const startVal = startValue;
    const endVal = children;
    const change = endVal - startVal;

    const animate = () => {
      const currentTime = Date.now();
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function (ease-out)
      const easeProgress = 1 - Math.pow(1 - progress, 3);

      setDisplayValue(startVal + change * easeProgress);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setDisplayValue(endVal);
      }
    };

    requestAnimationFrame(animate);
  }, [children, countUp, duration, startValue]);

  const formatter = new Intl.NumberFormat(locale, options);

  // Round to appropriate decimal places based on target
  const isInteger = Number.isInteger(children);
  const valueToFormat = isInteger ? Math.round(displayValue) : displayValue;

  return <>{formatter.format(valueToFormat)}</>;
};
